"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var annotationTransformer_1 = require("../../../common/helpers/annotationTransformer");
var AdminEditDocumentTemplateController = /** @class */ (function () {
    function AdminEditDocumentTemplateController($state, $stateParams, $scope, FlashService, $window, DocumentTemplateModel) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.FlashService = FlashService;
        this.$window = $window;
        this.DocumentTemplateModel = DocumentTemplateModel;
        this.busy = false;
        this.templateId = parseInt($stateParams.id, 10);
        this.template = null;
        // Initialize template data
        this.templateData = {
            name: "",
            description: "",
            status: "draft",
        };
        // Initialize component props for PDF editor
        this.editorProps = {
            mode: "create", // Use "create" mode for template editing (not "edit" which is for document completion)
            templateId: this.templateId,
            templateName: "",
            templateDescription: "",
            templateStatus: "draft",
            pdfUrl: null,
            initialAnnotations: [],
            initialSignatureRequirements: {
                document_level: [],
                field_level: {},
            },
        };
        // Initialize event handlers
        this.editorHandlers = {
            onSaveTemplate: this.handleTemplateUpdate.bind(this),
            onCancel: this.handleCancel.bind(this),
            onError: this.handleError.bind(this),
            onMetadataChange: this.handleMetadataChange.bind(this),
        };
        // Load the template
        this.loadTemplate();
    }
    AdminEditDocumentTemplateController.prototype.loadTemplate = function () {
        var _this = this;
        this.busy = true;
        this.DocumentTemplateModel.getTemplate(this.templateId)
            .then(function (response) {
            _this.template = response.data.template;
            // Update template data
            _this.templateData = {
                name: _this.template.name || "",
                description: _this.template.description || "",
                status: _this.template.status || "draft",
            };
            // Parse and transform annotations from backend format to frontend format
            var annotations = [];
            if (_this.template.annotations) {
                try {
                    var parsedAnnotations = typeof _this.template.annotations === "string"
                        ? JSON.parse(_this.template.annotations)
                        : _this.template.annotations;
                    // Check if annotations are in backend format (signature_boxes/form_fields)
                    // and transform to frontend format (flat array)
                    if ((0, annotationTransformer_1.isBackendFormat)(parsedAnnotations)) {
                        console.log("Transforming from backend format:", parsedAnnotations);
                        annotations = (0, annotationTransformer_1.transformAnnotationsFromBackend)(parsedAnnotations);
                        console.log("Transformed to frontend format:", annotations);
                    }
                    else {
                        // Already in frontend format
                        console.log("Annotations already in frontend format:", parsedAnnotations);
                        annotations = parsedAnnotations;
                    }
                }
                catch (e) {
                    console.error("Failed to parse annotations:", e);
                }
            }
            // Signature requirements no longer exist - signatures are now just form fields
            // with type='signature' in the annotations
            // Transform the file_url if it's an internal Minio URL
            var transformedPdfUrl = _this.template.file_url;
            // Log the URL transformation for debugging
            if (_this.template.file_url !== transformedPdfUrl) {
                console.log("Transformed PDF URL from:", _this.template.file_url);
                console.log("Transformed PDF URL to:", transformedPdfUrl);
            }
            // Update editor props with all template data
            _this.editorProps = __assign(__assign({}, _this.editorProps), { templateName: _this.template.name || "", templateDescription: _this.template.description || "", templateStatus: _this.template.status || "draft", pdfUrl: transformedPdfUrl, initialAnnotations: annotations });
            console.log("Editor props updated with:", {
                mode: _this.editorProps.mode,
                templateId: _this.editorProps.templateId,
                annotationsCount: annotations.length,
                annotations: annotations,
                pdfUrl: transformedPdfUrl,
                initialAnnotations: _this.editorProps.initialAnnotations,
            });
            // Trigger change detection
            _this.$scope.$applyAsync();
        })
            .catch(function (error) {
            console.error("Error loading template:", error);
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to load document template",
            });
            _this.$state.go("drivecoach.admin.documenttemplates");
        })
            .finally(function () {
            _this.busy = false;
        });
    };
    AdminEditDocumentTemplateController.prototype.handleTemplateUpdate = function (data) {
        var _this = this;
        if (this.busy) {
            return;
        }
        this.busy = true;
        // Validate template data
        var validation = this.DocumentTemplateModel.validateTemplate(data);
        if (!validation.valid) {
            this.FlashService.setMessage({
                type: "error",
                message: "Please fix the following errors: " + validation.errors.join(", "),
            });
            this.busy = false;
            return;
        }
        // Transform annotations to backend format
        var backendAnnotations = (0, annotationTransformer_1.transformAnnotationsForBackend)(data.annotations || []);
        // Prepare update data (no PDF file for updates)
        var updateData = {
            name: data.name || this.templateData.name,
            description: data.description || this.templateData.description,
            status: data.status || this.templateData.status,
            annotations: backendAnnotations,
            // signature_requirements removed - signatures are now part of annotations
        };
        this.DocumentTemplateModel.updateTemplate(this.templateId, updateData)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: "Document template updated successfully!",
            });
            _this.$state.go("drivecoach.admin.documenttemplates", {}, { reload: true });
        })
            .catch(function (error) {
            console.error("Error updating template:", error);
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to update document template. Please try again.",
            });
        })
            .finally(function () {
            _this.busy = false;
        });
    };
    AdminEditDocumentTemplateController.prototype.handleCancel = function () {
        this.$state.go("drivecoach.admin.documenttemplates");
    };
    AdminEditDocumentTemplateController.prototype.handleError = function (error) {
        console.error("PDF Editor Error:", error);
        this.FlashService.setMessage({
            type: "error",
            message: "An error occurred with the PDF editor. Please try again.",
        });
    };
    AdminEditDocumentTemplateController.prototype.handleMetadataChange = function (data) {
        // Update local template data when metadata changes in Vue component
        if (data.field === "name") {
            this.templateData.name = data.value;
        }
        else if (data.field === "description") {
            this.templateData.description = data.value;
        }
        else if (data.field === "status") {
            this.templateData.status = data.value;
        }
    };
    return AdminEditDocumentTemplateController;
}());
AdminEditDocumentTemplateController.$inject = [
    "$state",
    "$stateParams",
    "$scope",
    "FlashService",
    "$window",
    "DocumentTemplateModel",
];
exports.default = AdminEditDocumentTemplateController;
